import { render, staticRenderFns } from "./DealerLocator.vue?vue&type=template&id=f5a37c86"
import script from "./DealerLocator.vue?vue&type=script&lang=js"
export * from "./DealerLocator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports